export const Colors = {
  main: '#47af3c',
  lightMain: '#1e4d36',
  secondary: '#f6f6f6',
  lightSecondary: '#8e8e8e',
};
